import * as React from 'react';

const SortContext = React.createContext({});

export { SortContext };
